/**
 * Valores padrão para o componente ChecklistWindow
 */

import { ChecklistGroup } from '../types/checklist';

// Checklists padrão (alinhados ao conteúdo original do ChecklistWindow.tsx)
export const defaultChecklists: ChecklistGroup[] = [
  {
    title: 'Etapa 1 - Verificação do Sistema',
    automated: true,
    collapsed: true,
    description: 'Verificações automáticas realizadas pelo sistema',
    color: 'blue',
    items: [
      {
        id: '1',
        text: 'Verificação de dimensões dos arquivos',
        description: 'Sistema verifica automaticamente se as dimensões dos arquivos estão dentro dos padrões estabelecidos.',
        checked: true,
        automated: true
      },
      {
        id: '2',
        text: 'Cálculo de metragem total',
        description: 'Sistema calcula automaticamente a metragem total dos arquivos selecionados.',
        checked: true,
        automated: true
      },
      {
        id: '3',
        text: 'Validação do padrão de salvamento',
        description: 'Sistema verifica se os arquivos seguem o padrão de salvamento correto.',
        checked: true,
        automated: true
      }
    ]
  },
  {
    title: 'Etapa 2 - Confirmação Unificada (DEV)',
    description: 'Check único de desenvolvimento',
    color: 'green',
    collapsed: false,
    items: [
      {
        id: '4',
        text: 'Confirmar validações e termos',
        description: 'Check unificado para desenvolvimento: Processo, Qualidade, Revisão e Termos.',
        checked: false
      }
      // Itens originais comentados/removidos para simplificação:
      // - Realizar verificações de qualidade
      // - Revisar todo o processo
      // - Salvar documentação
      // - Concordo com os termos
    ]
  }
];